// extracted by mini-css-extract-plugin
export var formWrapper = "section_contact_form-module--formWrapper--sjLCx";
export var image = "section_contact_form-module--image--YbgjZ";
export var imageLeft = "section_contact_form-module--imageLeft--WnX2F";
export var imageRight = "section_contact_form-module--imageRight--UGlsk";
export var subtitle = "section_contact_form-module--subtitle--Wsn7B";